/* src/app/order/pages/order-quick-accounts/order-quick-accounts.component.scss */
/*# sourceMappingURL=order-quick-accounts.component.css.map */
